import React from 'react';
import dayjs from 'dayjs';
import './navbar.css';
import { connect } from 'react-redux';
import i18n from '@/i18n';
import { renderIf } from '@modules/utils';
import { hasPermission } from '@/constants/roles';
import Profile from './profile';
import GlobalSearch from './GlobalSearch';
import DashboardNotificationCenter from '@/shared/notification_center/DashboardNotificationCenter';
import { Icon } from '@ui';

const mapStateToProps = (state) => ({
  uUser: state.user,
});

class Navbar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      richieste: 0,
      soccorso: false,
    };
  }
  componentDidMount() {
    const start_str = dayjs().format('YYYY-MM-DD') + ' 00:01:00';
    const start = dayjs(start_str).toDate();
    let self = this;
    window.firebase
      .firestore()
      .collection('sos')
      .where('report_datetime', '>', start)
      .onSnapshot(function (col) {
        if (!col.empty) {
          //Abbiamo delle richieste di soccorso
          self.setState({
            richieste: col.docs.length,
            soccorso: true,
          });
        }
      });
  }
  togglePushMenu = (e) => {
    e.preventDefault();
    e.stopPropagation();
    const body = document.body;
    if (window.innerWidth >= 768) {
      body.classList.toggle('sidebar-collapse');
    } else {
      body.classList.toggle('sidebar-open');
    }
  };

  render() {
    return (
      <nav
        className={
          'main-header navbar navbar-expand navbar-navy ' +
          (this.state.soccorso ? i18n.t('soccorso') : '')
        }
      >
        <ul className="navbar-nav">
          <li className="nav-item">
            <a className="nav-link nav-toggle" href="#" onClick={this.togglePushMenu}>
              <Icon name="menu" />
            </a>
          </li>
        </ul>

        <GlobalSearch />

        <div className="navbar-spacer"></div>

        <div className="d-flex align-items-center gap-2">
          {renderIf(
            hasPermission(this.props.uUser?.role, 'MANAGE_USERS'),
            <DashboardNotificationCenter className="mr-2" />
          )}
          <Profile />
        </div>
      </nav>
    );
  }
}

export default connect(mapStateToProps, null)(Navbar);
